"use client"

import { Form, Row, Skeleton } from "antd"
import ProductColorsSkeleton from "./ProductColorsSkeleton"
import ProductSizesSkeleton from "./ProductSizes.skeleton"
import ProductQuantitySkeleton from "./ProductQuantity.skeleton"
import { useAppSelector } from "@/hooks/redux"

const ProductPanelSkeleton = () => {
  const productNameSetting = useAppSelector(state => state.store.store_setting.data.product_name)
  const productPriceSetting = useAppSelector(state => state.store.store_setting.data.product_price)
  return (
    <Form>
      <Row>
        <Skeleton
          styles={{
            title: {
              marginBottom: 0,
              height: `${productNameSetting.size / 10}rem`,
            }
          }}
          active
          paragraph={false}
        />
      </Row>
      <Row>
        <Skeleton
          styles={{
            title: {
              marginTop: '0.5rem',
              height: `${productPriceSetting.size / 10}rem`,
              width: "10rem"
            }
          }}
          paragraph={false}
        />
      </Row>

      <ProductColorsSkeleton />
      <ProductSizesSkeleton />
      {/* <BundleProducts /> */}
      <ProductQuantitySkeleton />

      <Row style={{ marginBlock: '2rem' }}>
        <Skeleton.Button style={{ height: `5rem` }} block size='large' />
      </Row>

      <Row>
        <Skeleton />
      </Row>
    </Form>
  )
}

export default ProductPanelSkeleton